import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./FooterNew.css";

const FooterNew = ({ userType = 1 }: { userType?: number }) => {
  return (
    <Container fluid className="footer-bg">
      <Container>
        <Row>
          <Col xs={12} style={{ marginLeft: "38px" }} className="desk">
            {userType === 1 && <p style={styles.title}>Quote of the day</p>}
          </Col>
          <Col lg={6} xs={12}>
            {userType === 1 ? (
              <Row>
                <Col xs={1} className="quoteWidth">
                  <span className="quote-start"> &#8220;</span>&nbsp;
                </Col>
                <Col xs={11} style={{ width: "85%" }}>
                  <span className="msg">
                    Either you run the day, or the day runs you. &nbsp;
                  </span>
                  <span className="quote-end">&#8221; </span>
                </Col>
              </Row>
            ) : null}
          </Col>
          <Col xs={12} className="mob" style={{ marginTop: "50px" }}>
            &nbsp;
          </Col>
          <Col sm={6} xs={12}>
            <Row>
              {/* <Col sm={12}>
                <p className="links">
                  <a href="/LegalDisclaimer" target="blank">
                    TERMS OF USE{" "}
                  </a>{" "}
                  |
                  <a href="/LegalDisclaimer" target="blank">
                    DISCLAIMER
                  </a>{" "}
                  |
                  <a href="/PrivacyPolicy" target="blank">
                    PRIVACY POLICY{" "}
                  </a>
                  |
                  <a href="/Sitemap" target="blank">
                    SITEMAP
                  </a>
                </p>
              </Col> */}
              <Col sm={12}>
                <p className="links">
                  Copyright 2015-2022 Mahindra &amp; Mahindra Ltd. All rights
                  reserved.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

const styles: any = {
  container: {
    backgroundColor: "#000",
    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0)), 
      linear-gradient(to bottom, #333333, #333333)`,
    padding: "30px 0px",
    color: "white",
    bottom: 0,
  },
  title: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    textTransform: "uppercase",
  },
  links: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    letterSpacing: "normal",
    textAlign: "right",
  },
};

export default FooterNew;
